export const locale = {
  startPage: {
    headText: "Vad vill du ha hjälp med?",
    startBooking: "Starta en bokning",
    nextFreeTime: "Nästa lediga tid från",
    whatOurCustomersSay: "Detta säger våra kunder om oss",
    recensions: "recensioner",
    seeAllRecensions: "See alla recensioner",
    bookAnAppointment: "Boka en tid med oss",
  },
  recensions: {
    heading: "Recensioner & Betyg",
  },
  choosePlace: {
    heading: "Välj plats",
  },
  chooseService: {
    heading: "Välj tjänst",
  },
  chooseWorker: {
    heading: "Välj utförare",
  },
  chooseTime: {
    heading: "Välj tid",
  },
  lastBookingStep: {
    heading: "Slutför bokning",
    openTicket: "Visa sammanfattning",
    closeTicket: "Göm sammanfattning",
    paymentMethod: "Betalningsmetod: Betala på plats",
    total: "Totalt",
    firstName: "Förnamn",
    lastName: "Efternamn",
    email: "Email",
    phone: "Telefonnummer",
    callNumber: "+46",
    addBookingNotes: "Lägg till notering",
    bookingNotes: "Notering",
    addBookingNotesDescription: "Meddela utföraren om något särskilt.",
    addBookingNotesPlaceholder: "Write booking notes...",
    save: "Spara",
    completeBooking: "Slutför bokning",
    byClickingCompleteBooking:
      'Genom att klicka på "Slutför bokning" accepterar du Bookybooks',
    termsAndConditions: "allmänna villkor.",
    cancelationPolicy: "Avbokningspolicy",
    cancelFreeFor: "Avboka gratis senast",
    before: "innan",
  },
  daysNames: {
    monday: "Mån",
    tuesday: "Tis",
    wednesday: "Ons",
    thursady: "Tor",
    friday: "Fre",
    saturday: "Lör",
    sunday: "Sön",
  },
  days: "dagar",
  hours: "timmar",
  minutes: "minuter",
  step: "Steg",
  currency: "kr",
  of: "av",
  at: "at",
  showMore: "Show more",
  to: "to",
  oneDayAgo: "1 dag sedan",
  poweredBy: "Powered by",
  verifiedByBB: "Verified by Bookybook",
  terms: "Villkoren",
  with: "with",
  iAccept: "Jag accepterar",
};
